import React, { useEffect,useState,useRef } from 'react';

const useResLoading=(props)=>{
  const {res=[],isBackground=true,run=false,name=''}=props;
  const [loading,setLoading] = useState(run?1:0);
  const [complete,setComplete] = useState(false);
  const refResLoading =useRef();
  refResLoading.current = {loading,setLoading,setComplete};

  const initLoadRes=()=>{
    if(complete)return;
    setLoading(res.length);
    res.forEach(src=>{
      var img = new Image();
      img.onload=()=>{
        if(refResLoading.current.loading-1<=0){
          refResLoading.current.setComplete(true);
        }
        refResLoading.current.setLoading((value)=>value-1);
        console.log(`[${name}]:${refResLoading.current.loading}`)
      }
      img.src=src;
    });
  }

  useEffect(()=>{
  },[loading])
  useEffect(()=>{
    if(run){
      initLoadRes();
    }
  },[])
  
  const action={
    loading,
    complete,
    run:initLoadRes,
  }
  return action;
}

export default useResLoading;
